import {createRequest, axios, defaultcancelRefer, Error} from './lube/RequestFactory';
import {
    getEnv,
    getPokeUser,
    getH5ParametersDict,
    getH5Parameters,
    isIos,
    isNative,
} from './utils.js';
import {bridge} from './bridge.js';
import {Performance} from './Performance.js';
import {reportException} from './monitor.js';
//
const apiBlockCollection = {
    '/x/mv/info': '/x/mv/simple_info'
};
const _env = getEnv();
const pokeUser = getPokeUser();
const isTestEnv = window.location.host.indexOf('test.pokekara.com') != -1;
const _parametersDict = getH5ParametersDict();
const _parameters = getH5Parameters();

//
function _log(data) {
    data && (data.type = 'error') && (data.event = Error.EVENT);
    Performance.log(data);
}

function isDebug() {
    return isIos() && pokeUser.is_debug;
}

function debugResponse(url, response) {
    if (isDebug()) {
        //response 上报给客户端，用于测试抓包
        bridge.post('debug_api_response', {
            url: url,
            response: response
        });
    }
}

function debugRequest(url) {
    if (isDebug()) {
        //request 上报给客户端，用于测试抓包
        bridge.post('debug_api_request', {
            url: url
        });
    }
}

function handleRequestHeader(headers) {
    if (pokeUser.poke_session_id) {
        headers['x-poke-session-id'] = pokeUser.poke_session_id;
    }
}
//
const _request = createRequest({
    baseUrl: 'https://api.pokekara.com',
    testBaseUrl: 'http://test.api.pokekara.com',
    mockBaseUrl: 'http://test.pokekara.com',
    isTestEnv: isTestEnv,
    env: _env,
    sendLog: _log,
    debugRequest: debugRequest,
    debugResponse: debugResponse,
    logException: reportException,
    isNative: isNative(),
    allowNativeRequest: pokeUser.allows_native_request,
    apiBlockCollection: apiBlockCollection,
    handleRequestHeader: handleRequestHeader,
    parametersDict: _parametersDict,
    parameters: _parameters
});


export {_request as request, axios, defaultcancelRefer, Error};
